import { DynamicColumn, DynamicWorkflowNode } from './dynamic-framework.models';

export function copyDynamicColumn(field: DynamicColumn): DynamicColumn {
  return {
    ...field,
    defaultValue: field.defaultValue
      ? { ...field.defaultValue, columnKey: field.key }
      : null,
    options: field.options.map(option => ({ ...option })),
  };
}

export function listWorkflowFields(
  nodes: DynamicWorkflowNode[],
  activeOnly = false,
): DynamicColumn[] {
  const fields = new Map<string, DynamicColumn>();
  nodes.forEach(node => node.fields.forEach(field => {
    if ((activeOnly && !field.isActive) || fields.has(field.key)) return;
    fields.set(field.key, copyDynamicColumn(field));
  }));
  return [...fields.values()];
}

export function listWorkflowRecordFields(
  nodes: DynamicWorkflowNode[],
  requiredNodeKey: string,
): DynamicColumn[] {
  const requiredFieldKeys = new Set(
    nodes.find(node => node.key === requiredNodeKey)?.fields
      .filter(field => field.isActive && field.isRequired)
      .map(field => field.key) ?? [],
  );
  return listWorkflowFields(nodes, true).map(field => ({
    ...field,
    isRequired: requiredFieldKeys.has(field.key),
  }));
}

export function updateSharedField(
  nodes: DynamicWorkflowNode[],
  oldKey: string,
  selectedNodeKey: string,
  selectedFieldIndex: number,
  updated: DynamicColumn,
): DynamicWorkflowNode[] {
  return nodes.map(node => ({
    ...node,
    fields: node.fields.map((field, fieldIndex) => {
      if (field.key !== oldKey) return field;
      const selected = node.key === selectedNodeKey && fieldIndex === selectedFieldIndex;
      return copyDynamicColumn({
        ...updated,
        isRequired: selected ? updated.isRequired : field.isRequired,
        sortOrder: field.sortOrder,
      });
    }),
  }));
}
